<template>
  <div class="container" v-if="loadingPageOver" :style="iosOrAndroidStyle">
    <w-navbar
      :icon="'iconchevron-left'"
      nav_title="设备管理"
      @mobileLeftBtn="leftBtnClick"
			v-show="iosOrAndroidShow"
    >
      <span slot="rightContent" class="toggle-batch-button"
        :class="[batchDeletionStatus ? 'active' : '']"
        @click="batchDeletion"
        v-if="deviceList.length"
      >{{ batchDeletionStatus ? '确认删除' : '批量删除' }}</span>
    </w-navbar>

    <div class="device-tips">最多可以设置 3 个常用设备，达到上限后每 7 天只能修改一次</div>

    <w-more-loading v-if="deviceLoading"/>
    <w-no-results text="暂时没有设备" v-else-if="!deviceList.length"/>

		<div class="device-list" v-else>
      <div class="device-item" v-for="(item,index) in deviceList" :key="index">
        <div class="device-head">
          <div class="name">{{item.device_name}}</div>
          <div class="action-deleted" v-if="item.deleted_at">已删除</div>
          <template v-else>
            <div class="action-delete"
              v-if="!batchDeletionStatus"
              @click="deleteDeviceItem(item, index)"
            >删除设备</div>
            <div class="checkbox" v-else
              :class="[item.select ? 'active': '']"
              @click="selectItem(item, index)"
            >
              <span class="iconfont iconduoxuankuang" v-if="item.select"></span>
              <span class="iconfont iconduoxuankuang1" v-else></span>
            </div>
          </template>
        </div>
        <div class="device-time">{{item.updated_at ? moment(item.updated_at).format('YYYY.MM.DD hh:mm:ss') : ''}}</div>
      </div>
    </div>

  </div>
</template>

<script>
import { envMixin, loginMixin } from '@/assets/js/mixin/global'
import { componentsMixin } from '@/assets/js/mixin/components'
import Cookies from "js-cookie";
const moment = require('moment')
//获取jwt里边的参数
import { getTUser } from '@/utils/utils'

import WNavbar from "@/components/global/w-navbar";
import WMoreLoading from '../../components/global/w-more-loading'
import WNoResults from './components/discuss-no-result'
 
export default {
    mixins: [ envMixin, loginMixin, componentsMixin ],
    data () {
      return {
        goBackIcon: 'iconchevron-left',
        deviceList: [], //设备列表
        batchDeletionStatus: false, //批量删除状态
        deviceLoading: false, //设备loading
        moment,
      }
    },
    computed: {},
    mounted () {
      this.loadPageData()
    },
    components: {
      WNavbar,
      WMoreLoading,
      WNoResults,
  },
    methods: {
      leftBtnClick() {
        this.$router.back();
      },
      getTUser() {
        let tUser = {};
        try {
          let _t = Cookies.get("_t");
          let tokenPayload = JSON.parse(window.atob(_t.split(".")[1]));
          tUser = tokenPayload.User;
        } catch (error) {}
        return tUser;
      },
      async loadPageData () {
        this.deviceLoading = true
        this.$api.cv.getCredibleEquipment({}).then((res) => {
          this.deviceLoading = false
          if (res.code === 1000) {
            let { devices } = res.data
            this.deviceList = devices.map(item => {
              item.select = false
              return item
            })
          }
        })
        .catch(() => {
          this.deviceLoading = false
          this.showToast('请求错误,请重试!')
        })

      },

      // 删除某个设备
      deleteDeviceItem(item, index){
        this.$createDialog({
          type: 'confirm',
          title: '提示',
          content: `是否删除此设备`,
          confirmBtn: {
            active: false,
            text: '取消'
          },
          cancelBtn: {
            active: true,
            text: '删除'
          },
          onCancel: async () => {
            let res = await this.$api.cv.deleteCredibleEquipment(item.device_number)
            // let res = {code:1000}
            if (res.code === 1000) {
              this.showToast('删除成功', 1500)
              this.loadPageData()
              this.batchDeletionStatus = false;
            }
          }
        }).show()
      },
      // 批量删除
      batchDeletion(){
        let selectList = this.deviceList.filter(item => item.select)
        if(!!this.batchDeletionStatus && selectList.length){
          console.log(selectList)
          this.$createDialog({
            type: 'confirm',
            title: '提示',
            content: `是否批量删除设备`,
            confirmBtn: {
              active: false,
              text: '取消'
            },
            cancelBtn: {
              active: true,
              text: '删除'
            },
            onCancel: async () => {
              let deviceNumbers = selectList.map(item => item.device_number)
              let data = {
                device_numbers: deviceNumbers
              }
              let res = await this.$api.cv.batchDelCredibleEquipment(data)
              // let res = {code:1000}
              if (res.code === 1000) {
                this.showToast('删除成功', 1500)
                this.loadPageData()
                this.batchDeletionStatus = false;
              }
            }
          }).show()
        }else{
          this.batchDeletionStatus = !this.batchDeletionStatus
        }
      },
      // 操作选中
      selectItem(item, index){
        this.deviceList[index].select = this.deviceList[index].select ? false : true
      },
    }
}
</script>
<style scoped lang="scss" rel="stylesheet/scss">
  @import '@/assets/scss/global/mixin';
  @import '@/assets/scss/global/variable.scss';

  .container {
    height: 100%;
		padding-top: 44px;
    min-height: 100vh;
    background: #F9F9F9;
    .toggle-batch-button{
      &.active{
        color: #FF4F4C;
      }
    }
  }

  .footer {
    @include ipx-content-bottom(1px);
  }
  .device-tips{
    color: $color-9c;
    line-height: 50px;
    text-align: center;
    font-size: 12px;
  }
  .device-list {
    background: #fff;
    padding: 0 20px;

    .device-item{
      height: 68px;
      border-bottom: 1px solid #F4F4F4;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &:last-child{
        border-bottom: 0;
      }
      .device-head{
        width: 100%;
        display: flex;
        height: 22px;
        align-items: center;
        .name{
          flex: 1;
          margin-right: 20px;
          font-size: 16px;
          color: #333;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .action-deleted{
          font-size: 14px;
          color: $color-9c;
        }
        .action-delete{
          font-size: 14px;
          color: #FF4F4C;
        }
      }
      .device-time{
        font-size: 12px;
        color: $color-9c;
        margin-top: 5px;
      }

      .checkbox{
        padding: 5px;
        color: #CFCFCF;
        &.active{
          color: #404040;
        }
      }
    }
  }

</style>
